"use client";

import { c as _c } from "react/compiler-runtime";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { RefObject } from "react";
type VoteFeedbackSource = "custom-submit" | "quick-amount";
const CUSTOM_AMOUNT_CONTROL_LABEL = "Change vote amount";
interface MemesQuickVoteCustomAmountRowProps {
  readonly allowsNegativeVotes: boolean;
  readonly customAmountLabel: string | null;
  readonly customInputRef: RefObject<HTMLInputElement | null>;
  readonly customValue: string;
  readonly feedbackSource: VoteFeedbackSource | null;
  readonly hasQuickAmounts: boolean;
  readonly isCustomRowVisible: boolean;
  readonly isSubmitting: boolean;
  readonly isVoteFeedbackActive: boolean;
  readonly onCustomChange: (value: string) => void;
  readonly onCustomSubmit: () => void;
  readonly onToggleCustom: () => void;
  readonly votingLabel: string | null;
}
export default function MemesQuickVoteCustomAmountRow(t0) {
  const $ = _c(47);
  const {
    allowsNegativeVotes,
    customAmountLabel,
    customInputRef,
    customValue,
    feedbackSource,
    hasQuickAmounts,
    isCustomRowVisible,
    isSubmitting,
    isVoteFeedbackActive,
    onCustomChange,
    onCustomSubmit,
    onToggleCustom,
    votingLabel
  } = t0;
  const t1 = isSubmitting && "tw-cursor-not-allowed tw-opacity-60";
  const t2 = isVoteFeedbackActive ? "tw-border-emerald-500/30 tw-bg-[#06110d]" : "focus-within:tw-border-primary-400";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = clsx("tw-relative tw-flex tw-h-full tw-w-full tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-iron-900 tw-bg-black tw-transition-colors desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:focus-within:tw-border-primary-400", t1, t2);
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-sr-only">{CUSTOM_AMOUNT_CONTROL_LABEL}</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = allowsNegativeVotes ? "-?[0-9]*" : "[0-9]*";
  const t6 = isCustomRowVisible ? undefined : -1;
  let t7;
  if ($[4] !== onCustomChange) {
    t7 = event => onCustomChange(event.target.value);
    $[4] = onCustomChange;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== onCustomSubmit) {
    t8 = event_0 => {
      if (event_0.key !== "Enter") {
        return;
      }
      event_0.preventDefault();
      onCustomSubmit();
    };
    $[6] = onCustomSubmit;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== customInputRef || $[9] !== customValue || $[10] !== isSubmitting || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <input ref={customInputRef} type="text" aria-label={CUSTOM_AMOUNT_CONTROL_LABEL} inputMode="numeric" pattern={t5} value={customValue} disabled={isSubmitting} tabIndex={t6} onChange={t7} onKeyDown={t8} className="tw-form-input tw-h-full tw-w-full tw-border-0 tw-bg-transparent tw-px-3 tw-pr-16 tw-text-base tw-font-semibold tw-text-iron-50 tw-outline-none tw-ring-0 focus:tw-ring-0 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 sm:tw-px-4 sm:tw-pr-20" />;
    $[8] = customInputRef;
    $[9] = customValue;
    $[10] = isSubmitting;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = votingLabel ?? "Votes";
  let t11;
  if ($[16] !== t10) {
    t11 = <span className="tw-pointer-events-none tw-absolute tw-right-3 tw-top-1/2 -tw-translate-y-1/2 tw-text-xs tw-font-bold tw-text-iron-500 sm:tw-right-4">{t10}</span>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t9) {
    t12 = <div className="tw-relative tw-h-full tw-w-full">{t9}{t11}</div>;
    $[18] = t11;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12 || $[22] !== t3) {
    t13 = <label className={t3}>{t4}{t12}</label>;
    $[21] = t12;
    $[22] = t3;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = customAmountLabel ? `Vote ${customAmountLabel}` : "Vote";
  let t15;
  if ($[24] !== onCustomSubmit) {
    t15 = () => {
      onCustomSubmit();
    };
    $[24] = onCustomSubmit;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = isCustomRowVisible ? undefined : -1;
  const t17 = isVoteFeedbackActive && feedbackSource === "custom-submit" ? "tw-border tw-border-solid tw-border-emerald-500/40 tw-bg-emerald-500/15 tw-text-emerald-100 tw-shadow-[0_0_20px_rgba(16,185,129,0.18)]" : "tw-border-0 tw-bg-primary-600 tw-text-white tw-shadow-[0_12px_24px_rgba(37,99,235,0.28)] desktop-hover:hover:tw-bg-primary-500";
  let t18;
  if ($[26] !== t17) {
    t18 = clsx("tw-inline-flex tw-h-full tw-shrink-0 tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-xl tw-px-5 tw-text-sm tw-font-bold tw-tracking-wide tw-transition-all active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 sm:tw-px-6 md:tw-px-4 lg:tw-px-6", t17);
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== feedbackSource || $[29] !== isVoteFeedbackActive) {
    t19 = isVoteFeedbackActive && feedbackSource === "custom-submit" ? <span className="tw-inline-flex tw-items-center tw-gap-1.5"><CheckIcon className="tw-size-4 tw-shrink-0" /><span>Voted</span></span> : "Vote";
    $[28] = feedbackSource;
    $[29] = isVoteFeedbackActive;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== isSubmitting || $[32] !== t14 || $[33] !== t15 || $[34] !== t16 || $[35] !== t18 || $[36] !== t19) {
    t20 = <button type="button" aria-label={t14} onClick={t15} disabled={isSubmitting} tabIndex={t16} className={t18}>{t19}</button>;
    $[31] = isSubmitting;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
    $[35] = t18;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== hasQuickAmounts || $[39] !== isCustomRowVisible || $[40] !== isSubmitting || $[41] !== onToggleCustom) {
    t21 = hasQuickAmounts && <button type="button" aria-label={`Close ${CUSTOM_AMOUNT_CONTROL_LABEL.toLowerCase()}`} onClick={onToggleCustom} disabled={isSubmitting} tabIndex={isCustomRowVisible ? undefined : -1} className="tw-inline-flex tw-h-full tw-w-11 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-white/[0.06] tw-text-iron-400 tw-transition-all active:tw-scale-95 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 desktop-hover:hover:tw-bg-white/10 desktop-hover:hover:tw-text-white sm:tw-w-12"><XMarkIcon className="tw-size-5 tw-flex-shrink-0" /></button>;
    $[38] = hasQuickAmounts;
    $[39] = isCustomRowVisible;
    $[40] = isSubmitting;
    $[41] = onToggleCustom;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t13 || $[44] !== t20 || $[45] !== t21) {
    t22 = <div className="tw-flex tw-h-full tw-items-stretch tw-gap-1.5 sm:tw-gap-2">{t13}{t20}{t21}</div>;
    $[43] = t13;
    $[44] = t20;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
}